import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import TRS from "../../Assets/Projects/TRS.png";
import HMS from "../../Assets/Projects/HMS.png";
import EMS from "../../Assets/Projects/EMS.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={TRS}
              isBlog={false}
              title="Teacher Rating System"
              description="
The Project Teacher Rating System is a comprehensive initiative aimed at evaluating and enhancing the performance of educators.
  This system employs student and peer feedback, as well as administrative assessments, to provide a holistic view of a teacher's effectiveness in the classroom. By gathering and analyzing these data points,
  schools can identify areas for improvement and recognize exceptional teaching.The goal is to promote continuous professional growth and ensure the best possible education for students."
              ghLink="https://github.com/Harshit-Thread/Teacher-Rating-System"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={HMS}
              isBlog={false}
              title="Hardware Management System"
              description="The Hardware Management System project is designed to streamline and optimize the management of an organization's physical IT assets. It involves tracking, monitoring, and maintaining hardware components such as servers, computers, and peripherals. This system helps in inventory management, maintenance scheduling, and resource allocation, ensuring efficient utilization and reducing downtime. By centralizing hardware data, organizations can make informed decisions, improve cost-efficiency, and enhance productivity, ultimately contributing to the smooth functioning of their IT infrastructure.."
              ghLink="https://github.com/Harshit-Thread/Hardware-Management-System"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={EMS}
              isBlog={false}
              title="Employee Management System"
              description="The Employee Management System project is a software solution designed to efficiently oversee an organization's workforce. It encompasses various HR functions, including personnel records, attendance tracking, payroll management, and performance evaluation. This system simplifies administrative tasks, enhances employee engagement, and ensures compliance with labor laws. By automating these processes, it streamlines operations, reducing manual errors and saving time. The Employee Management System is a vital tool for HR departments to foster a productive and well-managed workforce."
              ghLink="https://github.com/Harshit-Thread/Employee-Management-System"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
